import {Models, Storage} from "appwrite";
import {client} from "../lib/appwrite";
import {v4 as uuidv4} from 'uuid';
import {UploadFileItem} from "../types/upload";


const storage = new Storage(client);

export const uploadService = {

  async getFiles(props: { fileIds: string[], bucketId: string }): Promise<UploadFileItem[] | void> {
    const {fileIds, bucketId} = props
    let files: UploadFileItem[] = []
    try {
      for (const fileId of fileIds) {
        try {
          // Get file data by ID
          const file = await storage.getFile(bucketId, fileId) as unknown as UploadFileItem
          files = [...files, file]
        } catch (error) {
          console.error(`Error retrieving file with ID ${fileId}:`, error);
        }
      }
      return files as unknown as UploadFileItem []
    } catch (error) {
      console.error(`Error retrieving `, error);
    }
  },

  async uploadFile(props: { file: File, bucketId: string }): Promise<Models.File | void> {
    const {file, bucketId} = props
    try {
      const response: Models.File = await storage.createFile(
        bucketId,
        uuidv4(),
        file,
      );
      return response;
      // return response as unknown as string
    } catch (error) {
      console.error('Upload file error', error);
    }
  },

  async deleteFile(props: { fileId: string, buketId: string }): Promise<void> {
    const {fileId, buketId} = props
    try {
      const response = await storage.deleteFile(buketId, fileId);
    } catch (error) {
      console.error(error)
    }
  },

  async downloadFile(id: string): Promise<void> {
    try {
      const downloadLink = await storage.getFileDownload("6770fe4400025c7f2afb", id);
      if (typeof downloadLink === "string")
        window.open(downloadLink, '_blank');
    } catch (error) {
      console.error('Error downloading file: ', error);
    }
  }

}